import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import { API_URL } from '../constants/index';
import './Sidebar.css';

const Sidebar = ({ items, openProfilePage, onItemClick, fetchDocuments }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [uploadError, setUploadError] = useState(null); // Add uploadError state
  const [isUploading, setIsUploading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [isMobileOpen, setIsMobileOpen] = useState(true);

  const scrollContainerRef = React.useRef(null);

  const handleFileUpload = async (event) => {
    setIsUploading(true);
    setUploadError(null);
    const file = event.target.files[0];
    const data = new FormData();
    data.append('file', file);

    try {
      const token = await getAccessTokenSilently();
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(`${API_URL}/upload/`, data, config);
      console.log(response.data);
      fetchDocuments();
      setSelectedIndex(0);
      scrollContainerRef.current.scrollTop = 0;
    } catch (error) {
      console.log(error);
      if (error.response && error.response.status === 400) {
        setUploadError(JSON.stringify(error.response.data)); // Set the specific error message
      }
    } finally {
      setIsUploading(false);
      // Reset the file input value after upload
      event.target.value = '';
    }
  };

  const profileClick = () => {
    setSelectedIndex(''); // Set selectedIndex to empty value
    setUploadError(null);
    openProfilePage(); // Call the openProfilePage function
  };

  const toggleMobileSidebar = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  return (
    <>

      <div className={`sidebar-overlay ${isMobileOpen ? 'active' : ''}`} onClick={toggleMobileSidebar}></div>
      <div className="hamburger-menu" onClick={toggleMobileSidebar}>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className={`sidebar-container ${isMobileOpen ? 'open' : ''}`}>
        <div className="sidebar">
          <div className="file-upload">
            <h3 className="sidebar-header" style={{color: '#c62027' }}>New Screenplay</h3>
            <div className="custom-file-input">
              <label htmlFor="file-upload" className="button w-button">
                {isUploading ? 'Uploading...' : 'Upload'}
              </label>
              <input type="file" id="file-upload" onChange={handleFileUpload} disabled={isUploading} />
            </div>
            {uploadError && <p className="error-message">{uploadError}</p>} {/* Display the error message */}
          </div>

          <h4 className="sidebar-header">Screenplays</h4>
          <div className="list-section" ref={scrollContainerRef}>
            {items.length === 0 ? (
              <p>Waiting for you to upload your first screenplay! 🦊</p>
            ) : (
              <ul>
                {items.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      onItemClick(index);
                      setSelectedIndex(index);
                    }}
                    className={selectedIndex === index ? 'selected' : ''}
                  >
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="profile-icon" onClick={profileClick}>
            <span className="profile-icon">
              <img
                src="/profile2.png" // Assuming 'profile.png' is in the public folder
                alt="Profile Icon"
                className="profile-image" // Add a CSS class for styling
              />
              <span className="profile-text">Profile Page</span>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
